/* SOMEONE live upgrades: brands carousel (smooothy), style scene + scroll motion. Touches only the elements named below. */
(() => {
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('sxl-js');
  const pad = (n) => String(n).padStart(2, '0');
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const sliders = [];
  const AUTO = 3200;
  const GLYPHS = 'ABCDEFGHJKLMNOPRSTUVWXYZ0123456789#%&*+/<>';

  // ---------- brands carousel: cards fanned on an arc ----------
  const carousel = (root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const track = root.querySelector('[data-sxl-track]');
    const slides = [...track.children];
    const cards = slides.map((s) => s.firstElementChild);
    const total = cards.length;
    root.querySelector('[data-sxl-total]').textContent = pad(total);
    // images are lazy in the markup; start loading them shortly before the carousel reaches the screen
    const wake = () => root.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; });
    if ('IntersectionObserver' in window) { const o = new IntersectionObserver((es) => { if (es[0].isIntersecting) { wake(); o.disconnect(); } }, { rootMargin: '900px 0px' }); o.observe(root); } else wake();
    if (!window.Smooothy || still || total < 2) { root.classList.add('is-native'); return; }
    const cur = root.querySelector('[data-sxl-cur]');
    const timer = root.querySelector('[data-sxl-timer]');
    const show = (n) => {
      cur.textContent = pad(n + 1);
      cur.classList.remove('is-flip'); void cur.offsetWidth; cur.classList.add('is-flip');
      slides.forEach((s, k) => s.classList.toggle('is-active', k === n));
    };
    let tilt = 0;
    const s = new window.Smooothy(track, {
      infinite: true, snap: true, lerpFactor: 0.14, snapStrength: 0.08, speedDecay: 0.88,
      onSlideChange: (c) => show(((c % total) + total) % total),
      onUpdate: (core) => {
        if (!core.parallaxValues) return;
        tilt += (clamp(core.speed || 0, -1.5, 1.5) - tilt) * 0.12;
        core.parallaxValues.forEach((v, i) => {
          const x = clamp(v, -3, 3), a = Math.abs(x), el = cards[i];
          // arc: neighbours drop down and lean out like a hand of cards; drag speed bends the whole fan
          el.style.transform = `translateY(${(a * a * 7).toFixed(1)}%) rotate(${(x * 9 + tilt * -7).toFixed(2)}deg) scale(${(1 - Math.min(a, 2) * 0.13).toFixed(3)})`;
          el.style.opacity = clamp(1.6 - a * 0.55, 0, 1).toFixed(3);
          el.style.setProperty('--f', clamp(1 - a * 1.4, 0, 1).toFixed(3));
          slides[i].style.zIndex = String(10 - Math.round(a * 3));
        });
      },
    });
    let idle = 0, x0 = 0, next = performance.now() + AUTO;
    const hold = () => { idle = performance.now() + 4500; next = idle + AUTO; };
    track.addEventListener('pointerdown', (e) => { x0 = e.clientX; hold(); });
    track.addEventListener('click', (e) => { if (Math.abs(e.clientX - x0) > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    root.querySelector('[data-sxl-next]').addEventListener('click', () => { hold(); s.goToNext(); });
    root.querySelector('[data-sxl-prev]').addEventListener('click', () => { hold(); s.goToPrev(); });
    s.sxlTick = (now) => {
      if (!s.isVisible || s.isDragging || document.hidden || now < idle) { next = Math.max(next, now + 400); if (timer) timer.style.setProperty('--sxl-t', 0); return; }
      if (timer) timer.style.setProperty('--sxl-t', clamp(1 - (next - now) / AUTO, 0, 1).toFixed(3));
      if (now >= next) { s.goToNext(); next = now + AUTO; }
    };
    show(0);
    sliders.push(s);
  };

  // ---------- scroll motion ----------
  const split = (h) => {
    if (h.classList.contains('sxl-split')) return;
    const bold = !!h.querySelector('strong, b');
    const text = h.textContent.trim();
    if (!text) return;
    const ch = (c) => `<span class="sxl-ch" style="--d:${Math.round(Math.random() * 380)}ms">${c.replace(/[<&]/g, '')}</span>`;
    const html = text.split(/(\s+)/).map((w) => (/^\s+$/.test(w) ? ' ' : `<span style="display:inline-block;white-space:nowrap">${[...w].map(ch).join('')}</span>`)).join('');
    h.setAttribute('aria-label', text);
    h.innerHTML = bold ? `<strong aria-hidden="true">${html}</strong>` : `<span aria-hidden="true">${html}</span>`;
    h.classList.add('sxl-split');
  };

  // ---------- customer reviews: a deck of cards you flick away ----------
  const deck = (box) => {
    if (box.dataset.sxlDeck) return; box.dataset.sxlDeck = '1';
    const cards = [...box.querySelectorAll(':scope > .review-card-carousel')];
    if (cards.length < 2) return;
    box.classList.add('sxl-deck');
    box.parentElement.classList.add('sxl-deck-wrap');
    const ui = document.createElement('div'); ui.className = 'sxl-deck__ui';
    ui.innerHTML = '<button type="button" aria-label="הבא"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button><span><b>01</b> / ' + pad(cards.length) + '</span><button type="button" aria-label="הקודם"><svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg></button>';
    box.after(ui);
    const num = ui.querySelector('b');
    let order = cards.map((_, i) => i), busy = false, idle = 0, seen = 0;
    const size = () => box.style.setProperty('--sxl-h', `${Math.max(...cards.map((c) => c.offsetHeight)) + 36}px`);
    const lay = () => order.forEach((ci, d) => {
      const c = cards[ci];
      if (d <= 3) { const im = c.querySelector('img[data-sxl-src]'); if (im && !im.getAttribute('src')) im.src = im.dataset.sxlSrc; }
      c.classList.toggle('is-top', d === 0);
      c.style.zIndex = String(100 - d);
      // fanned stack: the next cards peek out on both sides
      const side = d % 2 ? 1 : -1, n = Math.min(Math.ceil(d / 2), 2);
      c.style.opacity = d > 4 ? '0' : '1';
      c.style.transform = d === 0 ? 'none' : `translateX(${side * n * 30}%) translateY(${n * 10}px) rotate(${side * n * 7}deg) scale(${1 - n * 0.1})`;
    });
    const fly = (dir, vy = 0) => {
      if (busy) return; busy = true;
      const c = cards[order[0]];
      c.classList.remove('is-drag'); c.classList.add('is-fly');
      c.style.transform = `translate(${dir * 120}vw, ${-70 + vy}px) rotate(${dir * (24 + Math.random() * 16)}deg) scale(.9)`;
      seen = (seen + 1) % cards.length; num.textContent = pad(seen + 1);
      setTimeout(() => { c.classList.remove('is-fly'); order.push(order.shift()); lay(); busy = false; }, 480);
    };
    const back = () => {
      if (busy) return;
      order.unshift(order.pop()); seen = (seen - 1 + cards.length) % cards.length; num.textContent = pad(seen + 1); lay();
    };
    let x0 = 0, y0 = 0, dx = 0, dy = 0, drag = null;
    box.addEventListener('pointerdown', (e) => {
      idle = performance.now() + 4000;
      const c = cards[order[0]]; if (busy || !c.contains(e.target)) return;
      drag = c; x0 = e.clientX; y0 = e.clientY; dx = dy = 0; idle = performance.now() + 4000;
      c.classList.add('is-drag'); c.setPointerCapture && c.setPointerCapture(e.pointerId);
    });
    window.addEventListener('pointermove', (e) => {
      if (!drag) return; dx = e.clientX - x0; dy = e.clientY - y0;
      drag.style.transform = `translate(${dx}px, ${dy * 0.35}px) rotate(${dx * 0.07}deg)`;
    });
    const up = () => {
      if (!drag) return; const c = drag; drag = null;
      if (Math.abs(dx) > 70) fly(Math.sign(dx), dy * 0.35); else { c.classList.remove('is-drag'); lay(); }
    };
    window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up);
    const [bNext, bPrev] = ui.querySelectorAll('button');
    bNext.addEventListener('click', () => { idle = performance.now() + 4000; fly(1); });
    bPrev.addEventListener('click', () => { idle = performance.now() + 4000; back(); });
    let vis = false;
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => { vis = es[0].isIntersecting; }).observe(box);
    setInterval(() => { if (vis && !drag && !document.hidden && performance.now() > idle) fly(Math.random() < 0.5 ? -1 : 1); }, 2300);
    size(); lay();
    cards.forEach((c) => c.querySelector('img')?.addEventListener('load', size));
    window.addEventListener('resize', size);
  };

  // ---------- footer: logo + running strip ----------
  const footer = () => {
    const f = document.querySelector('footer.footer');
    if (!f || f.classList.contains('sxl-foot')) return;
    f.classList.add('sxl-foot');
    const item = '<b>SOMEONE.</b><span>IDENTITY / STYLE</span><span>✦</span>';
    const strip = document.createElement('div'); strip.className = 'sxl-foot__strip'; strip.setAttribute('aria-hidden', 'true');
    strip.innerHTML = `<div>${item.repeat(4)}</div><div>${item.repeat(4)}</div>`;
    const brand = document.createElement('div'); brand.className = 'sxl-foot__brand';
    const logo = document.querySelector('.header__heading-logo');
    if (logo) { const img = logo.cloneNode(); img.removeAttribute('width'); img.removeAttribute('height'); img.alt = 'SOMEONE'; img.loading = 'lazy'; brand.appendChild(img); }
    f.prepend(brand); f.prepend(strip);
  };

  // ---------- crossed tapes: run on their own, speed up and flip with the scroll ----------
  const tapes = [];
  const tapeInit = () => document.querySelectorAll('[data-sxl-tape]').forEach((t) => {
    if (t.dataset.ready) return; t.dataset.ready = '1';
    const row = t.querySelector('.sxl-tape__row');
    row.innerHTML = row.innerHTML.repeat(4);
    tapes.push({ row, x: 0, dir: t.classList.contains('sxl-tape--b') ? 1 : -1, w: 0 });
  });

  // ---------- page transitions: a black curtain with the logo between pages ----------
  const navInit = () => {
    if (still || window.__sxlNav) return; window.__sxlNav = true;
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest('a[href]'); if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.closest('.cart-drawer, cart-drawer, #CartDrawer, .faq-popup, .predictive-search')) return;
      const u = new URL(a.href, location.href);
      if (u.origin !== location.origin || /^\/(cart|checkout|account)/.test(u.pathname) || u.pathname.includes('/checkouts/')) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      const c = document.getElementById('sxl-curtain'); if (!c) return;
      e.preventDefault();
      try { sessionStorage.setItem('sxl-nav', '1'); } catch (err) {}
      c.className = 'sxl-curtain is-in';
      setTimeout(() => { location.href = u.href; }, 480);
    });
    window.addEventListener('pageshow', (e) => { if (e.persisted) { const c = document.getElementById('sxl-curtain'); if (c) c.className = 'sxl-curtain'; } });
  };

  let bar = null, hero = null, grids = [], scenes = [], heads = [], lastY = window.scrollY, vel = 0, frame = 0, shaking = false;
  const io = ('IntersectionObserver' in window) ? new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    const el = e.target; io.unobserve(el);
    el.classList.add('is-in');
  }), { rootMargin: '0px 0px -8% 0px' }) : null;
  const watch = (el) => (io ? io.observe(el) : el.classList.add('is-in'));

  const init = () => {
    if (still) document.querySelectorAll('img[data-sxl-src]').forEach((i) => { i.src = i.dataset.sxlSrc; });
    footer();
    tapeInit();
    navInit();
    document.querySelectorAll('[data-sxl-cols]').forEach(carousel);
    scenes = [...document.querySelectorAll('[data-sxl-style]')];
    if (still) return;
    if (!bar) { bar = document.createElement('div'); bar.className = 'sxl-progress'; document.body.appendChild(bar); }
    hero = document.querySelector('.hero-wrapper');
    document.querySelectorAll('.reviews-carousel-container').forEach(deck);
    heads = [...document.querySelectorAll('.reviews-title-carousel, .rich-text__heading, [id*="__featured_collection"] .title')];
    heads.forEach((h) => { split(h); watch(h); });
    grids = [...document.querySelectorAll('[id*="__featured_collection"] .product-grid')];
    grids.forEach((g) => {
      g.classList.add('sxl-grid');
      const cols = window.innerWidth < 750 ? 2 : 4;
      [...g.children].forEach((li, k) => {
        if (li.dataset.k) return;
        li.dataset.k = k;
        li.style.setProperty('--i', `${(k % cols) * 180}ms`);
        li.style.setProperty('--k', (0.6 + ((k * 37) % 10) / 12).toFixed(2));
        const box = li.querySelector('.card__inner');
        if (box) box.insertAdjacentHTML('beforeend', '<span class="sxl-plinth"></span>');
        watch(li);
      });
    });
  };

  const loop = (now) => {
    sliders.forEach((s) => { s.update(); s.sxlTick && s.sxlTick(now); });
    const vh = window.innerHeight, y = window.scrollY;
    scenes.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      const p = clamp(-r.top / Math.max(1, el.offsetHeight - vh) * 1.15, 0, 1);
      const ease = (v) => 1 - Math.pow(1 - clamp(v, 0, 1), 3);
      const inout = (v) => { v = clamp(v, 0, 1); return v < 0.5 ? 4 * v * v * v : 1 - Math.pow(-2 * v + 2, 3) / 2; };
      const d = inout((p - 0.3) / 0.38);
      el.style.setProperty('--p', ease(p / 0.3).toFixed(4));
      el.style.setProperty('--d', d.toFixed(4));
      el.style.setProperty('--g', (Math.sin(Math.PI * d) * 0.9).toFixed(3));
      el.style.setProperty('--t', ease((p - 0.5) / 0.32).toFixed(4));
      el.classList.toggle('is-lit', p > 0.12);
      const b = clamp((p - 0.8) * 6, 0, 1);
      el.style.setProperty('--b', b.toFixed(3));
      const btn = el.querySelector('[data-sxl-style-btn]'); if (btn) btn.classList.toggle('is-live', b > 0.5);
    });
    tapes.forEach((t) => {
      if (!t.w) t.w = t.row.scrollWidth / 4;
      const boost = still ? 0 : clamp(Math.abs(vel) * 0.35, 0, 9);
      const flip = vel < -0.5 ? -1 : 1;
      t.x += t.dir * flip * (0.32 + boost * 0.35);
      if (t.w) { t.x = ((t.x % t.w) + t.w) % t.w; t.row.style.transform = `translate3d(${-t.x}px,0,0)`; }
    });
    if (!still) {
      if (bar) bar.style.transform = `scaleX(${(y / Math.max(1, document.documentElement.scrollHeight - vh)).toFixed(4)})`;
      if (hero) hero.style.setProperty('--sxl-hero', clamp(y / (hero.offsetHeight || vh), 0, 1).toFixed(4));
      vel += ((y - lastY) - vel) * 0.2; lastY = y;
      const vy = clamp(-vel * 1.3, -42, 42);
      grids.forEach((g) => g.style.setProperty('--sxl-vy', vy.toFixed(1)));
      // headings scramble into random characters while scrolling fast, then decode letter by letter
      const a = Math.abs(vel);
      if (a > 14 && (frame++ % 4 === 0)) {
        shaking = true;
        heads.forEach((h) => {
          const r = h.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
          if (now < (+h.dataset.cool || 0)) return;
          h.dataset.burst = '1';
          h.querySelectorAll('.sxl-ch').forEach((c) => {
            if (!c.dataset.c) { c.dataset.c = c.textContent; c.style.width = `${c.offsetWidth}px`; c.style.textAlign = 'center'; }
            if (c.dataset.c.trim() && Math.random() < 0.35) { c.textContent = GLYPHS[(Math.random() * GLYPHS.length) | 0]; c.classList.add('is-scr'); }
          });
        });
      } else if (a <= 6 && shaking) {
        shaking = false;
        heads.forEach((h) => {
          if (h.dataset.burst) { delete h.dataset.burst; h.dataset.cool = String(now + 3500); }
          h.querySelectorAll('.sxl-ch.is-scr').forEach((c, k) => {
            setTimeout(() => { c.textContent = c.dataset.c; c.classList.remove('is-scr'); }, 30 + k * 26);
          });
        });
      }
    }
    requestAnimationFrame(loop);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  requestAnimationFrame(loop);
})();
